// 쿠폰 자동발급 섹션 URL (2026-09-06 KST 추가)
import urlJoin from "url-join";

const voucherAutoIssueSection = "/voucher-auto-issue";

export const voucherAutoIssuePath = voucherAutoIssueSection;
export const voucherIssueListPath = urlJoin(voucherAutoIssueSection, "history");
